// This file is strictly for the controls n the Activities page
const buttonData = [
    {
        label: 'All',
        title: 'All Activities',
        value: 'all',
        img: 'https://i.imgur.com/wCqGUjS.png',
        description: "Houston’s activity scene offers something for everyone, from museum hopping in the Museum District to kayaking along Buffalo Bayou. Catch a game at Minute Maid Park, explore the Space Center, or stroll through Hermann Park. Whether you’re into art, sports, or the outdoors, Houston’s got exciting ways to spend your day."
    },
    {
        label: 'Attractions',
        value: 'attraction',
        img: 'https://i.imgur.com/8ysvujM.png',
        description: "Houston’s attractions showcase its rich culture and vibrant energy. Visit iconic spots like Space Center Houston, the Museum of Fine Arts, and the Houston Zoo. Explore the city’s diverse neighborhoods, lush parks, and interactive exhibits. Whether you're a first-time visitor or a local, Houston offers must-see sights for every interest."
    },
    {
        label: 'Bars',
        title: 'Bars & Lounges',
        value: 'bars',
        img: 'https://i.imgur.com/j9p10u8.png',
        description: "Houston’s bar scene is as diverse as the city itself, offering everything from sleek cocktail lounges to laid-back dive bars. Sip craft cocktails at Anvil, enjoy rooftop views at High & Dry, or catch live music at Axelrad. Whether you're into whiskey, wine, or local brews, Houston’s bars serve up great drinks and good vibes."
    },
    {
        label: 'Books',
        title: 'Bookstores & Libraries',
        value: 'books',
        img: 'https://i.imgur.com/8g9fACG.png',
        description: "Houston’s bookstores and libraries offer cozy spaces for readers and learners alike. Local gems like Brazos Bookstore and Kaboom Books feature curated selections and community events. The Houston Public Library system provides free access to books, tech, and programs across the city. Whether you're browsing shelves or studying in quiet corners, Houston’s literary spots inspire discovery."
    },
    {
        label: 'Coffee',
        title: 'Coffee, Tea, & Boba',
        value: 'coffee',
        img: 'https://i.imgur.com/slz9P1c.png',
        description: "Houston’s coffee, boba, and tea scene is a flavorful mix of cozy and trendy. Sip artisan brews at spots like Catalina Coffee, or grab creative boba drinks from The Teahouse and Sharetea. From matcha lattes to Vietnamese iced coffee, Houston’s cafes offer the perfect pick-me-up for every kind of sipper."
    },
    {
        label: 'Daiquiris',
        value: 'daiquiris',
        img: 'https://i.imgur.com/V4e8wMQ.png',
        description: "Houston's to-go daiquiri shops offer a fun and convenient way to enjoy frozen cocktails on the move. Popular spots like Daiquiri Island To Go and Daiquiris 2 Go serve up a wide variety of flavors, from classic margaritas and piña coladas to creative concoctions like 'Liquid Marijuana' and 'Jamaican Me Crazy.' These drive-thru establishments allow you to customize your drinks with toppings like gummies or candy, and many also offer tasty sides such as wings, mozzarella sticks, and shrimp baskets . Whether you're heading to a party or just want to unwind, Houston's to-go daiquiri shops make it easy to enjoy a refreshing cocktail without leaving your car."
    },
    {
        label: 'Markets',
        value: 'markets',
        img: 'https://i.imgur.com/mDDhpif.png',
        description: "Houston’s grocery scene is a global pantry, with options for every taste and need. Shop staples and local finds at H-E-B, specialty items at Whole Foods and Trader Joe’s, or explore international flavors at H Mart and Phoenicia. With fresh produce, diverse ingredients, and unique products, Houston’s markets make grocery shopping a culinary adventure."
    },
    {
        label: 'Museums',
        value: 'museum',
        img: 'https://i.imgur.com/lF1stXN.png',
        description: "Houston's museums offer a rich blend of art, science, history, and culture, making the city a hub for curious minds of all ages. From the world-renowned Museum of Fine Arts and the immersive exhibits at the Houston Museum of Natural Science to the innovative displays at the Contemporary Arts Museum and the family-favorite Children’s Museum, there's something for everyone. Whether you're exploring ancient artifacts, modern masterpieces, or hands-on science experiments, Houston’s Museum District delivers an inspiring and diverse experience in the heart of the city.s"
    },
    {
        label: 'Music',
        title: 'Music Venues',
        value: 'music',
        img: 'https://i.imgur.com/HSqVSQ6.png',
        description: "Houston’s music venue scene is alive with energy, offering spaces for every sound. From big-name acts at 713 Music Hall and House of Blues to intimate shows at White Oak Music Hall, the city pulses with live performances. Whether it’s indie, hip-hop, country, or jazz, Houston hits the right note for every music lover."
    },
    {
        label: 'Parks',
        value: 'parks',
        img: 'https://i.imgur.com/atLI6wu.png',
        description: "Houston’s parks and wildlife areas offer a refreshing escape into nature. Explore the lush trails of Memorial Park, spot wildlife at Brazos Bend State Park, or enjoy a peaceful stroll through Hermann Park. With scenic views, outdoor activities, and a rich diversity of ecosystems, Houston’s green spaces are perfect for nature lovers and adventurers alike."
    },
    {
        label: 'Photo',
        title: "Photo Opportunities",
        value: 'photo',
        img: 'https://i.imgur.com/nHaTrIi.png',
        description: "Houston’s aesthetic is a photographer’s dream, blending urban energy with natural beauty. Capture stunning skyline views from spots like Eleanor Tinsley Park, or snap the vibrant street art in the Heights and downtown. From serene nature shots in Hermann Park to the colorful murals scattered across the city, Houston offers endless opportunities for creative photography."
    },
    {
        label: 'Theaters',
        title: 'Movie Theaters',
        value: 'movies',
        img: 'https://i.imgur.com/MTomK59.png',
        description: "Houston’s movie theaters offer cinematic experiences for every kind of film fan. Catch blockbusters at AMC or Regal, enjoy dinner and a show at Alamo Drafthouse, or watch under the stars at Rooftop Cinema Club. With comfy seats, great snacks, and unique vibes, Houston’s theaters make movie night something special."
    },
]

export default buttonData;